/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 零元购免支付接口,返回支付订单id
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ZeroToBuyParams {
  constructor(
    public departmentId?: string,
    public orderId?: string,
    public orderType?:
      | "RECHARGE"
      | "SHOW"
      | "COMMODITY"
      | "VIDEO"
      | "CLOUD_THEATER_VIDEO",
    public payeeId?: string
  ) {}
}

export default async function (
  params: ZeroToBuyParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/zero-buy`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
